class _TextsStoreService {
	constructor(props) {
		this.props = props;
		
		this._TEXTS_DATA = window.WEBAPP_TEXTS;
		
		this.props.apiStoreService.fire('settings', {
			___onSuccess: (status, response) => {
				this._TEXTS_DATA = response.texts
				if (this.props.onLoaded) this.props.onLoaded(this._TEXTS_DATA);
			}
		});
	}
	
	getEntry(entry_path) {
		var BreakException = {};
		let e_path_array = entry_path.split('.');
		let _TMP = this._TEXTS_DATA;
		let ret = true;
		try {
			e_path_array.forEach((entry, idx) => {
				if (_TMP[entry] === undefined) {
					throw BreakException;
				}
				_TMP = _TMP[entry];
				ret = _TMP;
			});
		} catch(e) {
			if (e !== BreakException) throw e;
			ret = false;
		}
		return ret;
	}
	
	get(entry_path) {
		return this.getEntry(entry_path);
	}
}

export default _TextsStoreService;